/**
 * LOP — PLP Shop the Look (hotspot card + flyout)
 */
(function () {
  const MONEY_FORMAT = window.theme?.settings?.money_with_currency_format || window.theme?.settings?.money_format || '${{amount}}';

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, MONEY_FORMAT);
    }
    const amount = (cents / 100).toFixed(0);
    return `$${amount.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
  }

  function truncateTitle(title, maxLen = 12) {
    if (!title || title.length <= maxLen) return title;
    return `${title.slice(0, maxLen).trimEnd()}...`;
  }

  function getSectionsToRender() {
    return [
      { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-count' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-amount' }
    ];
  }

  class LopStlFlyout extends HTMLElement {
    constructor() {
      super();
      this.selection = [];
      this.heroData = null;
      this.heroVariantId = null;
      this.opened = false;
    }

    connectedCallback() {
      if (!this.dataset.lopStlPortaled && this.closest('#product-grid, .promotion-column')) {
        document.body.appendChild(this);
        this.dataset.lopStlPortaled = 'true';
      }

      this.overlay = this.querySelector('[data-lop-stl-close].lop-stl-flyout__overlay');
      this.closeBtns = this.querySelectorAll('[data-lop-stl-close]');
      this.atcBtn = this.querySelector('[data-lop-stl-atc]');
      this.toast = this.querySelector('[data-lop-stl-toast]');
      this.toastText = this.querySelector('[data-lop-stl-toast-text]');
      this.toastClose = this.querySelector('[data-lop-stl-toast-close]');
      this.selectionWrap = this.querySelector('[data-lop-stl-selection]');
      this.selectionTitle = this.querySelector('[data-lop-stl-selection-title]');
      this.selectionList = this.querySelector('[data-lop-stl-selection-list]');
      this.removeLabel = this.selectionWrap?.dataset.removeLabel || 'Remover';
      this.totalEl = this.querySelector('[data-lop-stl-total]');
      this.pinPopover = this.querySelector('[data-lop-stl-pin-popover]');
      this.heroJson = this.querySelector('[data-lop-stl-hero-json]');
      this.hotspotsJson = this.querySelector('[data-lop-stl-hotspots-json]');
      this.variantSelects = this.querySelector('variant-selects');

      this.heroData = null;
      this.hotspotsData = [];

      if (this.heroJson) {
        try {
          this.heroData = JSON.parse(this.heroJson.textContent);
        } catch (e) {
          console.error('lop-stl: hero json', e);
        }
      }

      if (this.hotspotsJson) {
        try {
          const parsed = JSON.parse(this.hotspotsJson.textContent);
          this.hotspotsData = Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          console.error('lop-stl: hotspots json', e);
        }
      }

      this.initDefaultSelection();
      this.bindEvents();
      this.updateUI();
    }

    bindEvents() {
      this.closeBtns.forEach((btn) => {
        btn.addEventListener('click', () => this.close());
      });

      this.addEventListener('click', (e) => {
        const addBtn = e.target.closest('[data-lop-stl-add-product]');
        if (addBtn) {
          e.preventDefault();
          this.addProduct({
            variantId: addBtn.dataset.variantId,
            title: addBtn.dataset.productTitle,
            price: parseInt(addBtn.dataset.productPrice, 10),
            image: addBtn.dataset.productImage,
            type: 'addon'
          });
        }
      });

      if (this.atcBtn) {
        this.atcBtn.addEventListener('click', () => this.addToCart());
      }

      if (this.toastClose) {
        this.toastClose.addEventListener('click', () => {
          this.toast.hidden = true;
        });
      }

      const variantsWrap = this.querySelector('[data-lop-stl-variants]');
      if (variantsWrap) {
        variantsWrap.addEventListener('change', (e) => {
          if (e.target.matches('input[type="radio"], select')) {
            this.onVariantChange();
          }
        });
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.opened) this.close();
      });
    }

    initHeroSelection() {
      if (!this.heroData) {
        return;
      }
      const needsSize = this.heroData.needs_size;
      this.heroVariantId = needsSize ? null : this.heroData.id;
      this.selection.push({
        variantId: needsSize ? null : String(this.heroData.id),
        title: this.heroData.title,
        price: this.heroData.price,
        image: this.heroData.featured_image,
        type: 'hero',
        needsSize
      });
    }

    initDefaultSelection() {
      this.selection = [];
      this.initHeroSelection();
    }

    getSelectedSizeValue() {
      const root = this.querySelector('[data-lop-stl-variants]');
      if (!root) return null;
      const checked = root.querySelector('.product-form__input--block:not(.lop-stl-flyout__option-hidden) input[type="radio"]:checked');
      return checked ? checked.value : null;
    }

    resetSizeSelection() {
      if (!this.heroData?.needs_size) return;

      const variantsRoot = this.querySelector('[data-lop-stl-variants]');
      if (variantsRoot) {
        variantsRoot.querySelectorAll('.product-form__input--block:not(.lop-stl-flyout__option-hidden) input[type="radio"]').forEach((input) => {
          input.checked = false;
        });
        variantsRoot.querySelectorAll('.product-form__input--block:not(.lop-stl-flyout__option-hidden) .form__label__value').forEach((label) => {
          label.textContent = '';
        });
      }

      this.heroVariantId = null;
      const heroItem = this.selection.find((s) => s.type === 'hero');
      if (heroItem) {
        heroItem.variantId = null;
        heroItem.selectedSize = null;
      }
    }

    open() {
      this.hidden = false;
      this.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        this.opened = true;
        document.documentElement.classList.add('overflow-hidden');
        this.initDefaultSelection();
        this.resetSizeSelection();
        this.syncHeroPricing();
        this.initVariantSelects();
        this.updateUI();
      });
    }

    initVariantSelects() {
      if (!this.variantSelects || typeof this.variantSelects.setDisabled !== 'function') {
        this.updateSizeLabels();
        return;
      }
      if (this.isSizeSelected()) {
        this.syncVariantSelects();
      } else {
        this.variantSelects.setDisabled();
        this.updateSizeLabels();
      }
    }

    updateSizeLabels() {
      const root = this.querySelector('[data-lop-stl-variants]');
      if (!root) return;
      root.querySelectorAll('fieldset[data-index]:not(.lop-stl-flyout__option-hidden)').forEach((fieldset) => {
        const label = fieldset.querySelector('.form__label__value');
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        if (label && checked) {
          label.textContent = checked.value;
        }
      });
    }

    getSelectedOptions() {
      const selectedOptions = [];
      const optionRoot = this.variantSelects || this;
      optionRoot.querySelectorAll('fieldset[data-index]').forEach((fieldset) => {
        const indexMatch = fieldset.dataset.index.match(/option(\d+)/);
        if (!indexMatch) return;
        const idx = parseInt(indexMatch[1], 10) - 1;
        const select = fieldset.querySelector('select');
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        if (select) {
          selectedOptions[idx] = select.value;
        } else if (checked) {
          selectedOptions[idx] = checked.value;
        }
      });
      return selectedOptions;
    }

    syncVariantSelects() {
      if (!this.variantSelects || typeof this.variantSelects.updateOptions !== 'function') return;
      this.variantSelects.updateOptions();
      this.variantSelects.updateMasterId();
      this.variantSelects.updateVariantText();
      if (!this.variantSelects.changingGender) {
        this.variantSelects.setDisabled();
      }
    }

    syncHeroPricing() {
      const pricing = this.querySelector('[data-lop-stl-product-pricing]');
      if (!pricing || typeof window.lopProcesarDescuentosFicticiosEn !== 'function') return;
      if (!pricing.hasAttribute('data-cucardas-procesadas')) {
        window.lopProcesarDescuentosFicticiosEn(pricing);
      }
    }

    close() {
      this.classList.remove('is-open');
      this.opened = false;
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('overflow-hidden');
      if (this.pinPopover) this.pinPopover.hidden = true;
      setTimeout(() => {
        if (!this.opened) this.hidden = true;
      }, 300);
    }

    showPinPopover(pinBtn) {
      if (!this.pinPopover) return;
      const title = pinBtn.dataset.productTitle;
      const rect = pinBtn.getBoundingClientRect();
      this.pinPopover.textContent = title;
      this.pinPopover.hidden = false;
      this.pinPopover.style.left = `${rect.left + rect.width / 2}px`;
      this.pinPopover.style.top = `${rect.top - 8}px`;
      this.pinPopover.style.transform = 'translate(-50%, -100%)';

      clearTimeout(this._pinTimer);
      this._pinTimer = setTimeout(() => {
        this.pinPopover.hidden = true;
      }, 2500);
    }

    onPinClick(pinBtn) {
      if (!this.opened) return;
      this.addProduct({
        variantId: pinBtn.dataset.productId,
        title: pinBtn.dataset.productTitle,
        price: parseInt(pinBtn.dataset.productPrice, 10) || 0,
        image: pinBtn.dataset.productImage || '',
        type: 'addon',
        fromPin: true
      });
    }

    onVariantChange() {
      const jsonEl = this.querySelector('.product-variants-json');
      if (!jsonEl || !this.heroData) return;

      let variants;
      try {
        variants = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return;
      }

      this.syncVariantSelects();

      const selectedOptions = this.getSelectedOptions();

      const match = variants.find((v) =>
        v.options.every((opt, i) => selectedOptions[i] === undefined || opt === selectedOptions[i])
      );

      if (match) {
        this.heroVariantId = match.id;
        const heroItem = this.selection.find((s) => s.type === 'hero');
        if (heroItem) {
          heroItem.variantId = String(match.id);
          heroItem.price = match.price;
          heroItem.available = match.available;
          heroItem.selectedSize = this.getSelectedSizeValue();
        }
        const heroImg = this.querySelector('[data-lop-stl-hero-image]');
        if (heroImg && match.featured_image?.src) {
          heroImg.src = match.featured_image.src;
        }
      }
      this.updateSizeLabels();
      this.updateUI();
    }

    addProduct(item) {
      const exists = this.selection.some((s) => s.variantId === String(item.variantId) && s.type === 'addon');
      if (exists) return;

      if (item.fromPin && !item.price) {
        const carouselBtn = this.querySelector(`[data-lop-stl-add-product][data-variant-id="${item.variantId}"]`);
        if (carouselBtn) {
          item.price = parseInt(carouselBtn.dataset.productPrice, 10);
          item.image = carouselBtn.dataset.productImage;
        }
      }

      this.selection.push({
        variantId: String(item.variantId),
        title: item.title,
        price: item.price || 0,
        image: item.image || '',
        type: item.type || 'addon'
      });
      this.updateUI();
    }

    removeProduct(variantId) {
      const item = this.selection.find((s) => s.variantId === String(variantId));
      if (item?.type === 'hero') return;
      this.selection = this.selection.filter((s) => s.variantId !== String(variantId));
      this.updateUI();
    }

    updateUI() {
      const hero = this.selection.find((s) => s.type === 'hero');
      const addons = this.selection.filter((s) => s.type === 'addon');
      const count = this.selection.length;
      const needsSize = hero?.needsSize;
      const sizeSelected = !needsSize || this.isSizeSelected();

      if (this.selectionWrap) {
        this.selectionWrap.hidden = count === 0;
      }

      if (this.selectionTitle) {
        const baseLabel = this.selectionTitle.dataset.baseLabel || 'Tu selección';
        this.selectionTitle.textContent = `${baseLabel} (${count})`;
      }

      if (this.selectionList) {
        this.selectionList.innerHTML = '';
        this.selection.forEach((item) => {
          const li = document.createElement('li');
          const safeTitle = String(item.title || '')
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/</g, '&lt;');
          const safeSize = item.selectedSize
            ? String(item.selectedSize)
                .replace(/&/g, '&amp;')
                .replace(/"/g, '&quot;')
                .replace(/</g, '&lt;')
            : '';
          li.className = `lop-stl-flyout__selection-item${item.type === 'hero' ? ' lop-stl-flyout__selection-item--hero' : ''}${item.type === 'hero' && needsSize && !sizeSelected ? ' is-disabled' : ''}`;
          li.innerHTML = `
            ${item.image ? `<img src="${item.image}" alt="" width="48" height="48" loading="lazy">` : ''}
            <span class="lop-stl-sel-item-title" title="${safeTitle}">${truncateTitle(item.title)}</span>
            ${item.type === 'hero' && safeSize ? `<span class="lop-stl-sel-item-size">${safeSize}</span>` : ''}
            ${item.type !== 'hero' ? `<button type="button" class="lop-stl-flyout__selection-remove" data-remove-id="${item.variantId}">${this.removeLabel}</button>` : `<button type="button" class="lop-stl-flyout__selection-remove" data-remove-id="${item.variantId}" ${needsSize ? '' : 'hidden'}>${this.removeLabel}</button>`}
          `;
          const removeBtn = li.querySelector('[data-remove-id]');
          if (removeBtn && item.type !== 'hero') {
            removeBtn.addEventListener('click', () => this.removeProduct(item.variantId));
          }
          this.selectionList.appendChild(li);
        });
      }

      let total = 0;
      this.selection.forEach((item) => {
        if (item.price) total += item.price;
      });

      if (this.totalEl) {
        if (total > 0 && sizeSelected) {
          this.totalEl.hidden = false;
          this.totalEl.textContent = formatMoney(total);
        } else {
          this.totalEl.hidden = true;
        }
      }

      if (this.atcBtn) {
        const hasItems = this.selection.length > 0;
        this.atcBtn.classList.remove('is-awaiting-size', 'is-ready');

        if (!hasItems) {
          this.atcBtn.disabled = true;
          this.atcBtn.classList.add('is-awaiting-size');
          this.atcBtn.textContent = this.atcBtn.dataset.labelSize || 'Elegir talle';
        } else if (!sizeSelected) {
          this.atcBtn.disabled = true;
          this.atcBtn.classList.add('is-awaiting-size');
          this.atcBtn.textContent = this.atcBtn.dataset.labelSize || 'Elegir talle';
          if (this.toast && this.toastText) {
            this.toast.hidden = false;
            this.toastText.textContent = this.toast.dataset.defaultText || 'Elegí un talle para completar el look.';
          }
        } else {
          this.atcBtn.disabled = false;
          this.atcBtn.classList.add('is-ready');
          this.atcBtn.textContent = this.atcBtn.dataset.labelAtc || 'Agregar al carrito';
          if (this.toast) this.toast.hidden = true;
        }
      }
    }

    isSizeSelected() {
      if (!this.heroData?.needs_size) return true;
      const fieldsets = this.querySelectorAll('.product-form__input--block:not(.lop-stl-flyout__option-hidden)');
      if (!fieldsets.length) return true;
      return Array.from(fieldsets).every((fieldset) =>
        fieldset.querySelector('input[type="radio"]:checked')
      );
    }

    async addToCart() {
      if (!this.atcBtn || this.atcBtn.disabled) return;

      this.atcBtn.classList.add('loading');
      this.atcBtn.setAttribute('aria-disabled', 'true');

      const formData = new FormData();
      let itemIndex = 0;
      this.selection.forEach((item) => {
        if (!item.variantId) return;
        formData.append(`items[${itemIndex}][id]`, item.variantId);
        formData.append(`items[${itemIndex}][quantity]`, 1);
        itemIndex += 1;
      });
      formData.append('sections', getSectionsToRender().map((s) => s.section).join(','));
      formData.append('sections_url', window.location.pathname);

      try {
        const response = await fetch(window.theme.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/javascript'
          },
          body: formData
        });
        const data = await response.json();

        if (data.status) {
          throw new Error(data.description || data.message);
        }

        if (data.sections) {
          getSectionsToRender().forEach((section) => {
            const el = document.getElementById(section.id);
            if (!el) return;
            const parser = new DOMParser();
            const html = parser.parseFromString(data.sections[section.section], 'text/html');
            const target = html.querySelector(section.selector);
            if (target) {
              const destination = el.querySelector(section.selector) || el;
              destination.innerHTML = target.innerHTML;
            }
          });
        }

        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: data } }));
        this.close();
      } catch (err) {
        console.error('lop-stl cart', err);
        if (this.toast && this.toastText) {
          this.toast.hidden = false;
          this.toastText.textContent = err.message || 'No se pudo agregar al carrito.';
        }
      } finally {
        this.atcBtn.classList.remove('loading');
        this.atcBtn.removeAttribute('aria-disabled');
      }
    }
  }

  if (!customElements.get('lop-stl-flyout')) {
    customElements.define('lop-stl-flyout', LopStlFlyout);
  }

  function syncStlCardHeights() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    grid.querySelectorAll('.lop-stl-promotion-column').forEach((col) => {
      const card = col.querySelector('[data-lop-stl-card]');
      const media = col.querySelector('.lop-stl-card__media');
      if (!card || !media) return;

      if (isMobile) {
        card.style.removeProperty('min-height');
        card.style.removeProperty('height');
        media.style.removeProperty('height');
        media.style.removeProperty('min-height');
        return;
      }

      const productCol = col.nextElementSibling?.matches?.('li.columns:not(.promotion-column)')
        ? col.nextElementSibling
        : col.previousElementSibling?.matches?.('li.columns:not(.promotion-column)')
          ? col.previousElementSibling
          : null;

      const productCard = productCol?.querySelector('.product-card');
      const targetHeight = productCard?.getBoundingClientRect().height;

      if (targetHeight && targetHeight > 0) {
        card.style.minHeight = `${targetHeight}px`;
      }
    });
  }

  // Espacio (px) que necesita el bubble por encima del pin (alto bubble + gap)
  var LOP_STL_BUBBLE_CLEARANCE = 70;

  // Decide arriba/abajo según el espacio real disponible en el viewport,
  // no un umbral fijo dentro del tile (evita que en notebooks se vaya abajo).
  function setPinBubbleDirection(pin) {
    pin.classList.remove('is-bubble-top', 'is-bubble-bottom');
    const pinRect = pin.getBoundingClientRect();
    // Si no entra el bubble arriba (pin cerca del borde superior del viewport) → baja
    if (pinRect.top < LOP_STL_BUBBLE_CLEARANCE) {
      pin.classList.add('is-bubble-bottom');
    }
  }

  function positionPinBubbles(card) {
    card.querySelectorAll('[data-lop-stl-pin]').forEach(setPinBubbleDirection);
  }

  function initCards(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-lop-stl-card]').forEach((card) => {
      if (card.dataset.lopStlInit) return;
      card.dataset.lopStlInit = 'true';

      const flyoutId = card.dataset.flyoutId;
      const flyout = document.getElementById(flyoutId);
      if (!flyout) return;

      card.querySelectorAll('[data-lop-stl-pin]').forEach((pin) => {
        // Recalcular dirección del bubble justo antes de mostrarlo (preciso ante scroll/resolución)
        pin.addEventListener('pointerenter', () => setPinBubbleDirection(pin));
        pin.addEventListener('focus', () => setPinBubbleDirection(pin));
        pin.addEventListener('click', (e) => {
          e.stopPropagation();
          setPinBubbleDirection(pin);
          card.querySelectorAll('[data-lop-stl-pin].is-pin-active').forEach((p) => {
            if (p !== pin) p.classList.remove('is-pin-active');
          });
          pin.classList.toggle('is-pin-active');
          if (typeof flyout.onPinClick === 'function') flyout.onPinClick(pin);
        });
      });

      const openBtn = card.querySelector('[data-lop-stl-open]');
      if (openBtn) {
        openBtn.addEventListener('click', () => {
          if (typeof flyout.open === 'function') flyout.open();
        });
      }

      positionPinBubbles(card);
    });

    syncStlCardHeights();
    document.querySelectorAll('[data-lop-stl-card]').forEach(positionPinBubbles);
  }

  let resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      syncStlCardHeights();
      document.querySelectorAll('[data-lop-stl-card]').forEach(positionPinBubbles);
    }, 150);
  }

  let scrollTicking = false;
  function onScroll() {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(() => {
      document.querySelectorAll('[data-lop-stl-card]').forEach(positionPinBubbles);
      scrollTicking = false;
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initCards();
    window.addEventListener('resize', onResize);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('load', () => {
      syncStlCardHeights();
      document.querySelectorAll('[data-lop-stl-card]').forEach(positionPinBubbles);
    });
  });
  document.addEventListener('shopify:section:load', (e) => initCards(e.target));
})();
